import { ScrollArea } from '@/components/shadcn/scroll-area'
import {
  Sheet,
  // SheetClose,
  SheetContent,
  SheetDescription,
  SheetTitle,
  SheetHeader,
  // SheetFooter,
  // SheetHeader,
  // SheetTitle,
  SheetTrigger,
} from '@/components/shadcn/sheet'
import clsx from 'clsx'

export function ComposedSheet({
  trigger,
  title,
  description,
  children,
}: {
  trigger: React.ReactNode
  title?: string
  description?: string
  children: React.ReactNode
}) {
  return (
    <Sheet>
      <SheetTrigger asChild>{trigger}</SheetTrigger>
      <SheetContent className="pr-0">
        {title && (
          <SheetHeader className="sticky inset-0 border-b pb-5">
            <SheetTitle>{title}</SheetTitle>
            {description && <SheetDescription>{description}</SheetDescription>}
          </SheetHeader>
        )}
        {/* <ScrollArea className={title ? 'h-[calc(100vh-86px-40px)]' : 'h-[calc(100vh-86px)]'}> */}
        <ScrollArea className={title ? 'h-[calc(100%-77px)]' : 'h-full'}>
          <div className="pl-1 pr-6">{children}</div>
        </ScrollArea>
        {/* {children} */}
        {/* <SheetFooter>
          <SheetClose asChild>
            <Button type="submit">Save changes</Button>
          </SheetClose>
        </SheetFooter> */}
      </SheetContent>
    </Sheet>
  )
}
